import React, { useState, useEffect } from "react";
import { marketDataService } from "../../utils/services/marketDataService";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import {
  Box,
  Tooltip,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
  Paper,
  Collapse,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import { isMobile } from "../../globalStyles/mobile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTheme } from "@mui/styles";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import EditIcon from "../../globalStyles/icons/editIcon";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import MarketDataModal from "../market-data-view-modal";
import { useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "none",
    // color: theme.palette.common.black,
    padding: "4px",
    textAlign: "start",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "4px",
    textAlign: "start",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const DropskipToolTableCell = ({
  x,
  handleViewClick,
  handleEditClick,
  handleDeleteClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleActionClick = (action) => {
    handlePopoverClose();
    switch (action) {
      case "view":
        handleViewClick(x);
        break;
      case "edit":
        handleEditClick(x);
        break;
      case "delete":
        handleDeleteClick(x);
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      <IconButton
        aria-label="more actions"
        onClick={(e) => {
          e.stopPropagation();
          handlePopoverOpen(e);
        }}
        sx={{
          color: open ? "primary.main" : "inherit",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", padding: 1 }}>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleActionClick("view");
            }}
            sx={{ textTransform: "none", justifyContent: "flex-start" }}
          >
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <ViewIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                View
              </Typography>
            </Box>
          </Button>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleActionClick("edit");
            }}
            sx={{ textTransform: "none", justifyContent: "flex-start" }}
          >
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <EditIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                Edit
              </Typography>
            </Box>
          </Button>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleActionClick("delete");
            }}
            sx={{ textTransform: "none", justifyContent: "flex-start" }}
          >
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <DeleteIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                Delete
              </Typography>
            </Box>
          </Button>
        </Box>
      </Popover>
    </Box>
  );
};
const MarketDataList = ({
  client,
  data,
  onEditData,
  onDeleteData,
  handleDeleteClient,
  viewMode,
  selectedDropskipTool,
  setSelectedDropskipTool,
  onChangeFilter,
  currentPage,
  itemsPerPage,
}) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [marketingTools, setMarketingTools] = useState([]);
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [expandedRow, setExpandedRow] = useState(null);
  const navigate = useNavigate();
  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const startIndex = currentPage * itemsPerPage;

  const handleDeleteClick = (x) => {
    setSelectedDropskipTool(x);
    setOpenConfirmation(true);
  };
  const handleEditClick = (x) => {
    localStorage.setItem("path", `/manage-market-data/${x?._id}`);
    navigate(`/manage-market-data/${x?._id}`);
  };

  const confirmDelete = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await marketDataService.delete(selectedDropskipTool._id);
      onDeleteData && onDeleteData();
      setOpenConfirmation(false);
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewClick = (x) => {
    setSelectedDropskipTool(x);
    setOpenViewModal(true);
  };
  useEffect(() => {
    setMarketingTools(
      data?.map((x) => ({
        ...x,
        action: (
          <DropskipToolTableCell
            x={x}
            handleViewClick={handleViewClick}
            handleEditClick={handleEditClick}
            handleDeleteClick={handleDeleteClick}
          />
        ),
      })),
    );
  }, [data]);
  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_product.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "300px" }}
      />
    </div>
  );
  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {marketingTools?.map((tool, index) => (
        <Grid sx={{ paddingBottom: 1 }} item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid var(--border-color)",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                }}
              >
                {tool?.action}
              </Box>

              <Grid container spacing={2}>
                {/* General Information */}
                <Grid item xs={12}>
                  <Typography
                    fontWeight="600"
                    sx={{ marginBottom: 1 }}
                    textAlign={"start"}
                  >
                    GENERAL INFORMATION
                  </Typography>
                </Grid>

                {[
                  { label: "Category", value: tool?.category },
                  { label: "Avg Order Weight", value: tool?.avg_order_weight },
                  {
                    label: "Avg Units per Order",
                    value: tool?.avg_units_per_order,
                  },
                  { label: "Avg Order Value", value: tool?.avg_order_value },
                  { label: "COGS (%)", value: `${tool?.cogs || "N/A"}%` },
                  { label: "Unit COGS", value: tool?.unit_cogs },
                  {
                    label: "B2B Fulfillment Cost",
                    value: tool?.b2b_fulfillment_cost,
                  },
                  {
                    label: "DS Fulfillment Cost",
                    value: tool?.ds_fulfillment_cost,
                  },
                ].map((item, index) => (
                  <Grid item xs={12} key={index} container>
                    <Grid item xs={6}>
                      <Typography
                        fontFamily={"poppins"}
                        fontWeight="500"
                        color="var(--text-tertiary)"
                        textAlign={"start"}
                      >
                        {item.label}:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ textAlign: "right" }}>
                      <Typography
                        fontFamily={"poppins"}
                        fontWeight="500"
                        color="#606060"
                      >
                        {item.value || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}

                {/* Merchandise Section */}
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      pt: 2,
                      textAlign: "start",
                    }}
                  >
                    MERCHANDISE
                  </Typography>
                </Grid>

                {tool?.merchandise?.length > 0 && (
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      mb: 2,
                      width: "100%",
                      position: "relative",
                      ml: 2,
                      mt: 1,
                    }}
                  >
                    <Grid container spacing={2}>
                      {/* Show only the first merchandise item */}
                      {[
                        {
                          label: "Merchandise Name",
                          value: tool?.merchandise[0]?.name,
                        },
                        {
                          label: "HS Code",
                          value: tool?.merchandise[0]?.hs_code,
                        },
                        {
                          label: "Duty Rate - Non China (%)",
                          value: `${
                            tool?.merchandise[0]?.duty_non_china || "N/A"
                          }%`,
                        },
                        {
                          label: "Duty Rate China (%)",
                          value: `${
                            tool?.merchandise[0]?.duty_rate_china || "N/A"
                          }%`,
                        },
                      ].map((field, fieldIndex) => (
                        <Grid item xs={12} key={fieldIndex} container>
                          <Grid item xs={6}>
                            <Typography
                              fontWeight="500"
                              color="var(--text-tertiary)"
                              textAlign="start"
                            >
                              {field.label}:
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sx={{ textAlign: "right" }}>
                            <Typography fontWeight="500" color="#606060">
                              {field.value}
                            </Typography>
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                )}
                {tool?.merchandise.length > 1 && (
                  <Box
                    sx={{
                      justifyContent: "flex-end",
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="primary"
                      sx={{
                        cursor: "pointer",
                        fontWeight: "600",
                        textAlign: "end",
                      }}
                      onClick={() => handleViewClick(tool)}
                    >
                      More...
                    </Typography>
                  </Box>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 20,
        marginTop: 5,
      }}
    >
      {isMobile() ? (
        renderGridView()
      ) : (
        <TableContainer
          sx={{
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    SL NO
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      fontSize="14px"
                      title={true}
                      color="var(--text-tertiary)"
                      fontWeight={500}
                      fontFamily={"poppins"}
                    >
                      Category
                    </Typography>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomTypography
                      fontSize="14px"
                      title={true}
                      color="var(--text-tertiary)"
                      fontWeight={500}
                    >
                      Merchandise
                    </CustomTypography>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomTypography
                      fontSize="14px"
                      title={true}
                      color="var(--text-tertiary)"
                      fontWeight={500}
                    >
                      {`Avg. Order Weight (lbs)`}
                    </CustomTypography>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                    textAlign={"start"}
                  >
                    Avg. Units per Order
                  </CustomTypography>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomTypography
                      fontSize="14px"
                      title={true}
                      color="var(--text-tertiary)"
                      fontWeight={500}
                    >
                      Avg. Order Value{" "}
                    </CustomTypography>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                  >
                    COGS%
                  </CustomTypography>
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                  >
                    Unit COGS
                  </CustomTypography>
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                  >
                    B2B Fulfill Cost
                  </CustomTypography>
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                  >
                    DS Fulfill Cost
                  </CustomTypography>
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                  ></CustomTypography>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {marketingTools?.length === 0 ? (
                <StyledTableRow>
                  <TableCell colSpan={11} align="center">
                    <NoDataImage />
                  </TableCell>
                </StyledTableRow>
              ) : (
                marketingTools?.map((x, index) => (
                  <React.Fragment key={index}>
                    <StyledTableRow
                      style={{ cursor: "pointer", height: 50 }}
                      onClick={() => toggleRow(index)}
                    >
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"Poppins"}
                          style={{
                            marginLeft: 7,
                            minWidth: 50,
                            maxWidth: 50,
                          }}
                        >
                          {startIndex + index + 1}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"poppins"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                          }}
                        >
                          {x?.category}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          style={{
                            marginLeft: 10,
                            maxWidth: 200,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"Poppins"}
                        >
                          {x?.merchandise?.length}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"poppins"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                            marginLeft: 10,
                          }}
                        >
                          {x?.avg_order_weight}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"poppins"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                            marginLeft: 10,
                          }}
                        >
                          {x?.avg_units_per_order}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"poppins"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "250px",
                            marginLeft: 10,
                          }}
                        >
                          {x.avg_order_value}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"poppins"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "250px",
                            marginLeft: 1,
                          }}
                        >
                          {x.cogs}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"poppins"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "250px",
                            marginLeft: 1,
                          }}
                        >
                          {x.unit_cogs}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"poppins"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "250px",
                            marginLeft: 1,
                          }}
                        >
                          {x.b2b_fulfillment_cost}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"poppins"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "250px",
                            marginLeft: 1,
                          }}
                        >
                          {x.ds_fulfillment_cost}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{ width: "3%", textAlign: "center" }}
                      >
                        {x.action}
                      </StyledTableCell>
                    </StyledTableRow>
                    {expandedRow === index && (
                      <StyledTableRow>
                        <TableCell colSpan={11} sx={{ padding: "8px 16px" }}>
                          <Collapse
                            in={expandedRow === index}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box sx={{ marginY: 1 }}>
                              <Typography
                                variant="subtitle2"
                                fontWeight={500}
                                gutterBottom
                              >
                                Merchandise Details (
                                {x.merchandise?.length || 0})
                              </Typography>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        backgroundColor: "#000000",
                                        color: "#FFFFFF",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Name
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        backgroundColor: "#000000",
                                        color: "#FFFFFF",
                                        fontWeight: 500,
                                      }}
                                    >
                                      HS Code
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        backgroundColor: "#000000",
                                        color: "#FFFFFF",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Duty Non-China
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        backgroundColor: "#000000",
                                        color: "#FFFFFF",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Duty Rate China
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {x.merchandise?.map((item, i) => (
                                    <TableRow key={i}>
                                      <TableCell
                                        sx={{
                                          fontSize: "12px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {item.name}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          fontSize: "12px",
                                          color: "var(--text-secondary)",
                                        }}
                                      >
                                        {item.hs_code}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          fontSize: "12px",
                                          color: "var(--text-secondary)",
                                        }}
                                      >
                                        {item.duty_non_china}%
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          fontSize: "12px",
                                          color: "var(--text-secondary)",
                                        }}
                                      >
                                        {item.duty_rate_china}%
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </StyledTableRow>
                    )}
                  </React.Fragment>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return (
    <div sx={{ minWidth: "100%" }}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: isMobile()
              ? `calc(100vh - 210px)`
              : `calc(100vh - 250px)`,
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" ? renderGridView() : renderListView()}
        </div>
      )}

      <DeleteConfirmationModal
        DeleteConfirmationModal
        title={`Are you sure you want to delete ${selectedDropskipTool?.category} category?`}
        open={openConfirmation}
        handleClose={() => setOpenConfirmation(false)}
        handleDelete={(e) => {
          confirmDelete(e);
        }}
      />

      <MarketDataModal
        handleClose={() => setOpenViewModal(false)}
        selectedDropskipTool={selectedDropskipTool}
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
      />
    </div>
  );
};

export default MarketDataList;
